import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ClientFactoringByCesionarioDTO } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/interface/minute-request-kpis.interface';

@Component({
  selector: 'app-factoring-fac-pdf',
  templateUrl: './factoring-fac-pdf.component.html',
  styleUrls: ['./factoring-fac-pdf.component.scss']
})
export class FactoringFacPdfComponent {
  @Input() factoringByCesionario: Array<ClientFactoringByCesionarioDTO>;
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  public dataSource!: MatTableDataSource<ClientFactoringByCesionarioDTO>;
  public displayedColumns: string[] = ['cesionarioName', 'transferedInvoiceTotalAmount', 'numTransferedInvoices'];

  constructor() {
    this.factoringByCesionario = new Array<ClientFactoringByCesionarioDTO>();
  }

  ngOnInit(): void {
    this.setDataSource(this.factoringByCesionario);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setDataSource(this.factoringByCesionario);
  }

  private setDataSource(factoringCesionario: Array<ClientFactoringByCesionarioDTO>) {
    this.dataSource = new MatTableDataSource<ClientFactoringByCesionarioDTO>(factoringCesionario);
    this.dataSource.sort = this.sort;
  }
  
}
